import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Menu from './components/Menu';
import QRCodeSection from './components/QRCode';
import Footer from './components/Footer';

function App() {
  const getInitialSection = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const s = params.get('section');
      if (s === 'menu' || s === 'qr') return s;
      if (s === 'home') return 'menu';
    } catch (e) {}
    return 'menu';
  };

  const [currentSection, setCurrentSectionState] = useState(getInitialSection);

  const setCurrentSection = (section) => {
    setCurrentSectionState(section);
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('section', section);
      window.history.replaceState({}, '', url);
    } catch (e) {}
  };

  useEffect(() => {
    const cls = 'fullpage-menu';
    const updateHeaderHeight = () => {
      try {
        const headerEl = document.querySelector('.header');
        const headerHeight = headerEl ? headerEl.offsetHeight : 80;
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      } catch (e) {}
    };

    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);

    try {
      if (currentSection === 'menu') {
        document.body.classList.add(cls);
      } else {
        document.body.classList.remove(cls);
      }
    } catch (e) {}

    return () => {
      window.removeEventListener('resize', updateHeaderHeight);
      try { document.body.classList.remove(cls); } catch (e) {}
    };
  }, [currentSection]);

  return (
    <div className="App">
      <Header setCurrentSection={setCurrentSection} />
      
      <main className="main-content">
        {currentSection === 'menu' && <Menu />}
        {currentSection === 'qr' && <QRCodeSection />}
      </main>

      <Footer />
    </div>
  );
}

export default App;
